module.exports = __webpack_public_path__ + "static/media/one_marker.81b8bf2b.svg";